module.exports = "<div ng-if=vm.errorOccurred translate>News overview cannot be shown</div> <div class=\"r newsitems {{vm.viewMode}}\" ng-if=!vm.errorOccurred> <div class=c ng-repeat=\"news in vm.newsitems\"> <news-tile parent-state=vm.parentState badge-clicked=vm._badgeClicked(categoryId) news=news></news-tile> </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./features/news/components/news-grid.html
// module id = 604
// module chunks = 0